// import './Button.scss'
// import React from 'react'

// function Button({
//     type = 'button',
//     variant = '',
//     link,
//     onClick,
//     children,
//     ariaLabel,
//     target,
//     rel,
//     className = '',
// }) {
//     if (type === 'link') {
//         return (
//             <a
//                 href={link}
//                 className={`button ${variant} ${className}`}
//                 aria-label={ariaLabel}
//                 target={target}
//                 rel={rel}
//             >
//                 {children}
//             </a>
//         )
//     }

//     return (
//         <button
//             type="button"
//             className={`button ${variant} ${className}`}
//             onClick={onClick}
//             aria-label={ariaLabel}
//         >
//             {children}
//         </button>
//     )
// }

// export default Button

import './Button.scss'
import React from 'react'

function Button({
    type = 'button',
    variant = '',
    href,
    onClick,
    children,
    ariaLabel,
    target,
    rel,
    className = '',
}) {
    if (type === 'link') {
        return (
            <a
                href={href}
                className={`button ${variant} ${className}`}
                aria-label={ariaLabel}
                target={target}
                rel={rel}
            >
                {children}
            </a>
        )
    }

    return (
        <button
            type="button"
            className={`button ${variant} ${className}`}
            onClick={onClick}
            aria-label={ariaLabel}
        >
            {children}
        </button>
    )
}

export default Button